import Vue from 'vue'
import VueI18n from 'vue-i18n'

import locale from '@/configs/locale.js'

Vue.use(VueI18n)

window.loadedLocales = []

const i18n = new VueI18n({
  locale: locale.currentLocale,
  silentTranslationWarn: true
})

export default i18n
